import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PlantList } from '../models/plant-manager.model';
import { SeachedHierarchy } from '../../idms/idms-site-search/models/siteSearchTaggedItemModel';

@Injectable({
    providedIn: 'root',
})
export class PlantmanagerService {
    selectedHierarchyId: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    updatedSchema: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    updateFormAfterCalculation: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false); //Form mark as dirty to update after recalculate
    StatusDisabled: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    ExceptionOrLeakSaveStatus: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    AdditionalInfo: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    updateForm: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    updateDocumentByTaggedItem: BehaviorSubject<PlantList> = new BehaviorSubject<PlantList>(null);
    UpdateActiveTaggedItem: BehaviorSubject<PlantList> = new BehaviorSubject<PlantList>(null);
    headers: HttpHeaders;
    loggedInUserId: string;
    IsGrid: boolean; //For changing the view type in plant manager
    activeTaggedItem: PlantList;
    activeLineOrEquipmentTaggedItem: PlantList;
    refreshTaggedItemRoot: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    activeTaggedItemForAddChild: PlantList; //Only for Add child option click from plant manager card
    isAllocated: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    LatestVersionTaggedItemId: string;
    selectedline: PlantList;
    updateJointName: BehaviorSubject<PlantList> = new BehaviorSubject<PlantList>(null);
    saveAfterToolSelection: boolean = false;
    IsSaveFromTool: boolean = false;
    DocGrid: string; //For changing the view type in plant manager
    taggedItemType: string; //For changing the view type in plant manager
    tmpShowFlangeTab: boolean; //For changing the view type in plant manager
    taggedItemHierarchy?: SeachedHierarchy[]; //For changing the view type in plant manager
    viewTaggedItemEdit: BehaviorSubject<PlantList> = new BehaviorSubject<PlantList>(null);
    updateTaggedItemEdit: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    isOpenChild: boolean = false;
    currentCalculationType: string = '';
    loadToolSelection: BehaviorSubject<any> = new BehaviorSubject<any>(null);
}
